import { client } from './axiosClient';
import { DatevAggregatedItem, DatevFile } from '../types';
import { AxiosResponse } from 'axios';

export interface PostGenerateDatevInput {
  month: number;
  year: number;
}

export const getDatev = async (company_id?: string) => {
  const res = await client.get<DatevFile[]>('/client/datev/search', {
    params: {
      company_id,
    },
  });
  return res.data;
};

export const getReportResultFileLink = async (
  id: number,
  company_id?: string
) => {
  const res = await client.post(`/client/datev/download/${id}`, '', {
    params: {
      company_id,
    },
  });
  return res.data;
};

export const getDatevLedgerAggregated = async (
  company_id: string | undefined,
  year?: number,
  month?: number
) => {
  const res = await client.get<DatevAggregatedItem[]>(
    '/client/datev/ledger/aggregated',
    {
      params: {
        company_id,
        year,
        month,
      },
    }
  );
  return res.data;
};

export const getDatevLedger = async (
  company_id: string | undefined,
  year: number,
  month: number,
  page: number,
  entry_type?: number
) => {
  const res = await client.get('/client/datev/ledger', {
    params: {
      company_id,
      year,
      month,
      page,
      entry_type,
    },
  });
  return res.data;
};

export const postGenerateDatev = async (
  company_id: string,
  input: PostGenerateDatevInput
) => {
  const res = await client.post<
    PostGenerateDatevInput,
    AxiosResponse<DatevFile[]>
  >('/client/datev/generate', input, {
    params: {
      company_id,
    },
  });
  return res.data;
};
